export const SET_BENCHMARK_DONUT_ANALYSIS_AXIS_TO_DISPLAY = 'SET_BENCHMARK_DONUT_ANALYSIS_AXIS_TO_DISPLAY';

export const setBenchmarkDonutAnalysisAxisToDisplay = (donutAnalysisAxisToDisplay: string) => ({
  type: SET_BENCHMARK_DONUT_ANALYSIS_AXIS_TO_DISPLAY,
  data: donutAnalysisAxisToDisplay,
});
